<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple"
            v-preventReClick @click="handleDelete">取消</el-button>
          <!-- <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px;" @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column prop="operation" fixed="right" label="操作" width="160">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.state != 3" type="text" v-preventReClick
                  @click="handleDelete(scope.row)" class="margin-left20 color-blue">取消</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
       
      </div>
      <div v-else>
        <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column label="订单号" min-width="170" align="left" prop="no" >
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="科室代码" min-width="100" align="center" prop="deptNo">
          <template slot-scope="scope">
            {{ scope.row.deptNo?scope.row.deptNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column label="科室名称" min-width="100" align="center" prop="deptName">
          <template slot-scope="scope">
            {{ scope.row.deptName?scope.row.deptName:'-' }}
          </template>
        </el-table-column>
        <el-table-column label="医生工号" min-width="100" align="center" prop="doctorNo">
          <template slot-scope="scope">
            {{ scope.row.doctorNo?scope.row.doctorNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column label="医生姓名" min-width="100" align="center" prop="doctorName">
          <template slot-scope="scope">
            {{ scope.row.doctorName?scope.row.doctorName:'-' }}
          </template>
        </el-table-column>
        <el-table-column label="医生电话" min-width="100" align="center" prop="doctorPhone">
          <template slot-scope="scope">
            {{ scope.row.doctorPhone?scope.row.doctorPhone:'-' }}
          </template>
        </el-table-column>
        <el-table-column label="病历号" min-width="100" align="center" prop="patientNo">
          <template slot-scope="scope">
            {{ scope.row.patientNo?scope.row.patientNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column label="患者姓名" min-width="100" align="center" prop="patientName">
          <template slot-scope="scope">
            {{ scope.row.patientName?scope.row.patientName:'-' }}
          </template>
        </el-table-column>
        <el-table-column label="患者电话" min-width="100" align="center" prop="patientPhone">
          <template slot-scope="scope">
            {{ scope.row.patientPhone?scope.row.patientPhone:'-' }}
          </template>
        </el-table-column>
        <el-table-column label="订单状态" min-width="180" align="center" prop="stateName" />
        <el-table-column label="总数量" min-width="100" align="center" prop="totalNumber" />
        <el-table-column label="总金额" min-width="100" align="center" prop="totalAmount" />
        <el-table-column prop="operation" fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.state != 3" type="text" v-preventReClick
              @click="handleDelete(scope.row)" class="margin-left20 color-blue">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
 

      <!-- <info :show="showInfo" :id="id" @handleClose="closeInfo"></info> -->
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import { CancelOtherOrder, GetOtherOrders } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import Info from './info';
import { OtherOrderStateOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      OtherOrderStateOptions: OtherOrderStateOptions,
      filterOptions: [
        {
          name: "订单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "科室",
          type: "input",
          code: "deptName",
        },
        {
          name: "患者名称",
          type: "input",
          code: "patientName",
        },
        {
          name: "患者电话",
          type: "input",
          code: "patientPhone",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "订单状态",
          type: "select",
          code: "states",
          data: OtherOrderStateOptions,
          multiple: true,
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
      ],
      showFinishOrderDialog: false,
      finishForm: {},
      finishRules: {
        remark: [
          {
            required: true,
            message: "请输入原因",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData() {
      GetOtherOrders(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查看信息
    handleInfo(row) {
      // this.$router.push("/other-order-edit?formMode=0&id=" + row.id);
      this.routePushWithParams("/other-order-edit", this.query, {
        formMode: 0,
        id: row.id,
      });
    },
    // 新建
    handleAdd() {
      // this.$router.push("/other-order-edit?formMode=1");
      this.routePushWithParams("/other-order-edit", this.query, {
        formMode: 1,
      });
    },
    // 编辑
    handleUpdate(row) {
      // this.$router.push("/other-order-edit?formMode=2&id=" + row.id);
      this.routePushWithParams("/other-order-edit", this.query, {
        formMode: 2,
        id: row.id,
      });
    },
    // 审批
    handleApprove(row) {
      // this.$router.push("/other-order-edit?formMode=3&id=" + row.id);
      this.routePushWithParams("/other-order-edit", this.query, {
        formMode: 3,
        id: row.id,
      });
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 删除部门
    handleDelete(row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          return CancelOtherOrder({
            ids,
          });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset() {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
    queryChange() {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    filterChange(query) {
      this.query = Object.assign(this.query, query);
      this.loading = true;
      this.getData();
    },

    // print (command) {
    //   const length = this.ids.length
    //   if (length !== 1) {
    //     this.$my_message('请选择一条数据', 'warning')
    //     return
    //   }

    //   var id = this.ids[0]
    //   GetPurchaseOrderPrintData({ id: id, type: command })
    //     .then(res => {
    //       var result = res.returnData

    //       var printData = this.printDataConvert(result.printData)
    //       this.sendPrintMessage(JSON.stringify(printData));
    //     })
    // },
  },
  created() {
    // 分页组件默认值需要早created
    if (this.$route.params) {
      this.query = this.$route.params;
    }
  },
  mounted() {
    // 查询组件默认值需要在mounted
    if (this.$route.params) {
      this.$refs["selectFilter"].query = this.query;
    }
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
